export default "/images/PhilippBamidele.jpg?f4fac84f4556ec91a5dabd131409cadd";